import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Ng2Select2BootstrapService {

  constructor() { }
}
